"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbilitySlot = void 0;
var AbilitySlot;
(function (AbilitySlot) {
    AbilitySlot[AbilitySlot["Ability1"] = 0] = "Ability1";
    AbilitySlot[AbilitySlot["Ability2"] = 1] = "Ability2";
    AbilitySlot[AbilitySlot["Ability3"] = 2] = "Ability3";
    AbilitySlot[AbilitySlot["Ability4"] = 3] = "Ability4";
    AbilitySlot[AbilitySlot["Ability5"] = 4] = "Ability5";
    AbilitySlot[AbilitySlot["Ability6"] = 5] = "Ability6";
    AbilitySlot[AbilitySlot["Ability7"] = 6] = "Ability7";
    AbilitySlot[AbilitySlot["Ability8"] = 7] = "Ability8";
    AbilitySlot[AbilitySlot["Ability9"] = 8] = "Ability9";
    AbilitySlot[AbilitySlot["Ability10"] = 9] = "Ability10";
})(AbilitySlot = exports.AbilitySlot || (exports.AbilitySlot = {}));
